import SVG from "react-inlinesvg";

import variables from "../../style/scss-variables.scss";
import ActivityDoneImg from "../../assets/Images/activity-done.png";
import CoachIcon from "../../assets/Images/coach.png";
import HoursIcon from "../../assets/Images/hours.png";
import NewCoachIcon from "../../assets/Images/newCoach.png";
import NewMemberIcon from "../../assets/Images/newMember.png";
import PaymentIcon from "../../assets/Images/payment.png";
import ScheduleIcon from "../../assets/Images/schedule.png";
import MemberIcon from "../../assets/Images/member.png";
import MinMemberIcon from "../../assets/Images/minMember.png";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import calendarIcon from "../../assets/Images/calendarIcon.png";
import timeIcon from "../../assets/Images/time.png";
import userDummy from "../../assets/Images/dummy.jpg";
import Group from "../../assets/Images/group.png";
import GroupDisable from "../../assets/Images/group_disable.png";
import Info from "../../assets/Images/info.png";

import GymStudio from "../../assets/Images/sidebar_gym_studio.png";
import calorie from "../../assets/Icon/calorie.svg";
import calorieIcon from "../../assets/Images/calorie.svg";
import calorieIconDisable from "../../assets/Images/calorie_Disable.svg";
import timerIcon1 from "../../assets/Icon/timer.svg";
import timerIcon from "../../assets/Images/timer.svg";
import verified from "../../assets/Images/icn_verified.svg";
import logo from "../../assets/Images/logo.png";
import filter from "../../assets/Icon/filter.svg";
import newLogo from "../../assets/Images/new_logo.svg";
import userCover from "../../assets/Images/userCover.png";
import Bitmap from "../../assets/Images/Bitmap.png";
import DefaultImage from "../../assets/Images/Bitmap.svg";
import check from "../../assets/Images/check.png";
import RequestUser from "../../assets/Images/request_user.png";
import RemoveUser from "../../assets/Images/removed_user.png";
import cardBackground from "../../assets/Images/cardBackground.png";
import americanExpress from "../../assets/Images/americanExpress.png";
import visaLogo from "../../assets/Images/visaLogo.png";
import diner from "../../assets/Images/diner.png";
import discover from "../../assets/Images/discover.png";
import jcb from "../../assets/Images/jcb.png";
import mastercard from "../../assets/Images/mastercard.png";
import union from "../../assets/Images/union.png";
import magentaCard from "../../assets/Images/magentaCard.svg";
import pinkCard from "../../assets/Images/pinkCard.svg";

// =================SIDEBAR ICONS========================
import dashboard from "../../assets/Images/sidebar_dashboard.png";
import Schedule from "../../assets/Images/sidebar_schedule.png";
import Ongoing from "../../assets/Images/sidebar_onGoingActivity.png";
import Activity from "../../assets/Images/sidebar/my_activity.svg";
import Recorded from "../../assets/Images/sidebar/recordedActivity.svg";
import Messages from "../../assets/Images/sidebar/messages.svg";
import Coaches from "../../assets/Images/sidebar/coaches.svg";
// import Members from '../../assets/Images/sidebar/members.svg';
import Members from "../../assets/Images/sidebar_members.png";
import Payments from "../../assets/Images/sidebar/payments.svg";
import Setting from "../../assets/Images/sidebar/settings.svg";
import onDemandActivity from "../../assets/Images/sidebar/onDemand.svg";
import onDemandActivityWhite from "../../assets/Images/sidebar/onDemandWhite.svg";
import upcomingClass from "../../assets/Images/sidebar/upcoming_class.svg";
import videoLibrary from "../../assets/Images/sidebar/video_library.svg";
import integration from "../../assets/Images/sidebar/integration.svg";
import classSummary from "../../assets/Images/sidebar/class_summary.svg";
// =========================================================

// ====================HEADER  ICONS =======================
import PlayIcon from "../../assets/Images/header_play.png";
import StopIcon from "../../assets/Images/header_stop.png";
import addCardFooterImage from "../../assets/Images/addCardFooterImage.png";
// =========================================================

// ====================PROFILE DROPDOWN ICONS ==============
import accountDetails from "../../assets/Images/profileDropdown/icn_account_detail.svg";
import agreements from "../../assets/Images/profileDropdown/icn_agreements.svg";
import privacyPolicy from "../../assets/Images/profileDropdown/icn_privacy_policy.svg";
import streamPlaceholder from "../../assets/Images/Artboard.svg";
import streamPlaceholder1 from "../../assets/Images/Artboard-1.svg";
import helpCenter from "../../assets/Images/profileDropdown/helpCenter.svg";
// =========================================================

// ==================== ZYM PROFILE ==============
import zym from "../../assets/profile/zym.png";
import zym1 from "../../assets/profile/zym1.png";
// =========================================================

// ==================== ANNOUNCEMENT ICONS ==============
import editIconAnnouncement from "../../assets/Icon/editIconAnnouncement.svg";
import deleteIconAnnouncement from "../../assets/Icon/deleteIconAnnouncement.svg";
import uploadImgPlaceholder from "../../assets/Icon/upload_img_placeholder.svg";
import noDataAnnouncement from "../../assets/Icon/noDataAnnouncement.png";
// =========================================================

// ==================== SPECIALISIMS ==============
import Running from "../../assets/Images/Running.png";
// import Dance from '../../assets/Images/Dance.png';
import Postnatal from "../../assets/Images/Postnatal.png";
import Strength from "../../assets/Images/Postnatal.png";
import Sports from "../../assets/Images/Sports.png";
import Stretch from "../../assets/Images/Stretch.png";
// import Strength from '../../assets/Images/Strength.png';
import Prenatal from "../../assets/Images/Prenatal.png";
import Motivation from "../../assets/Images/Motivation.png";
import Pilates from "../../assets/Images/Pilates.png";
import Boxing from "../../assets/Images/Boxing.png";
import Spinning from "../../assets/Images/Spinning.png";
import Medication from "../../assets/Images/Medication.png";
import Bootcamp from "../../assets/Images/Bootcamp.png";
import Core from "../../assets/Images/Core.png";
import Barre from "../../assets/Images/Barre.png";
import Rowing from "../../assets/Images/Rowing.png";
import Martial from "../../assets/Images/Martial.png";
import Elliptical from "../../assets/Images/Elliptical.png";
import checkImage from "../../assets/Images/checkImage.png";
import copyIcon from "../../assets/Images/copyIcon.png";
import activityImage from "../../assets/Images/activityImage.jpg";
import streamDisabled from "../../assets/Images/noStream.svg";
import noStreaming from "../../assets/Images/noStreaming.png";
import streamEnabled from "../../assets/Images/streamEnabled.svg";
import audioEnabled from "../../assets/Images/audioEnabled.svg";
import audioDisabled from "../../assets/Images/audioDisabled.png";
import userMike from "../../assets/Images/userMike.png";
import userMikeDisabled from "../../assets/Images/userMikeDisabled.png";
import Subtract from "../../assets/Images/Subtract1.svg";
import downloadInvoice from "../../assets/Images/downloadInvoice.png";
// =========================================================

import blackImage from "../../assets/Images/black.png";
import rejectUser from "../../assets/Images/reject_user.png";
import membersLive from "../../assets/Images/membersLive.png";
import memberLive from "../../assets/Icon/live.svg";
import mindBodyLogo from "../../assets/Images/mindBodyLogo.png";
import marianaTek from "../../assets/Images/marianaTek.png";
import companyPH from "../../assets/Images/companyLogo.svg";
import activationPending from "../../assets/Images/activationPending.png";
import downArrow from "../../assets/Images/downArrow.svg";
import arrow from "../../assets/Icon/arrow.svg";
import addMember from "../../assets/Images/addMember.svg";
import downloadIcon from "../../assets/Images/downloadIcon.svg";
import excelUpload from "../../assets/Images/excelUpload.svg";
import scheduleRoom from "../../assets/Images/scheduleRoom.svg";
import openRoom from "../../assets/Images/openRoom.svg";
import closedRoom from "../../assets/Images/closedRoom.svg";
import availableRoom from "../../assets/Images/availableRoom.svg";
import waitingRoom from "../../assets/Images/waitingRoom.svg";

import notValid from "../../assets/Images/NotValid.svg";
import validEmail from "../../assets/Images/validEmail.svg";
import passwordLock from "../../assets/Images/PaswordLock.svg";
import publicLock from "../../assets/Images/publicLock.svg";
import crossIcons from "../../assets/Images/crossIcon.svg";
import noStream from "../../assets/Images/noStream.svg";
import crossIcon from "../../assets/Icon/cross_icon.svg";
import arrowIcon from "../../assets/Icon/arrow_icon.svg";

import vod from "../../assets/Images/vod.svg";
import live from "../../assets/Images/live.svg";

// Template Icon
import deletes from "../../assets/Template/delete.svg";
import copy from "../../assets/Template/copy.svg";
import share from "../../assets/Template/share.svg";
import shareActive from "../../assets/Template/shareActive.svg";
import shareDisable from "../../assets/Template/shareDisable.svg";
import edit from "../../assets/Template/edit.svg";

// Activity Type
import barre from "../../assets/activityType/barre.svg";
import bootcamp from "../../assets/activityType/bootcamp.svg";
import boxing from "../../assets/activityType/boxing.svg";
import Calisthenics from "../../assets/activityType/calisthenics.svg";
import cardio from "../../assets/activityType/cardio.svg";
import celebrity from "../../assets/activityType/celebrity.svg";
import core from "../../assets/activityType/core.svg";
import cycling from "../../assets/activityType/cycling.svg";
import dance from "../../assets/activityType/dance.svg";
import Functional from "../../assets/activityType/functional.svg";
import hiit from "../../assets/activityType/hiit.svg";
import lowerBody from "../../assets/activityType/lowerBody.svg";
import meditation from "../../assets/activityType/meditation.svg";
import mobility from "../../assets/activityType/mobility.svg";
import other from "../../assets/activityType/other.svg";
import pilates from "../../assets/activityType/pilates.svg";
import seniorFitness from "../../assets/activityType/seniorFitness.svg";
import sports from "../../assets/activityType/sports.svg";
import streching from "../../assets/activityType/streching.svg";
import strengths from "../../assets/activityType/strength.svg";
import toning from "../../assets/activityType/toning.svg";
import upperBody from "../../assets/activityType/upperBody.svg";
import yoga from "../../assets/activityType/yoga.svg";

// Smile
import upset from "../../assets/smile/upset.svg";
// Icon
import dropdown from "../../assets/Icon/dropdown.svg";
import activeDown from "../../assets/Icon/activeDown.svg";
import down from "../../assets/Icon/down.svg";
import up from "../../assets/Icon/up.svg";
import activeUp from "../../assets/Icon/activeUp.svg";
import addTemplate from "../../assets/Icon/addTemplate.svg";
import search from "../../assets/Icon/search.svg";
import low from "../../assets/Icon/low.svg";
import medium from "../../assets/Icon/medium.svg";
import high from "../../assets/Icon/high.svg";
import noLevel from "../../assets/Icon/noLevel.svg";
import back from "../../assets/Icon/back.svg";

import gallaryView from "../../assets/Icon/gallary_view.svg";
import member from "../../assets/Icon/members.svg";
import sendIcon from "../../assets/Icon/send_icon.svg";
import segmentView from "../../assets/Icon/segment_view.svg";
import videoUnmute from "../../assets/Icon/video_unmute.svg";
import videoMute from "../../assets/Icon/video_mute.svg";
import downloadTransaction from "../../assets/Icon/download_transaction.svg";
import refund from "../../assets/Icon/refund.svg";
import pauseIcon from "../../assets/Icon/pause.svg";
import playIcons from "../../assets/Icon/play.svg";
import cross_input from "../../assets/Icon/cross_input.svg";

import template from "../../assets/Icon/template.svg";

import userMikeSVG from "../../assets/Icon/userMike.svg";
import userMikeDisabledSVG from "../../assets/Icon/userMikeDisabled.svg";

import offline from "../../assets/Images/noInternet.svg";
import audioEquilizer from "../../assets/Images/audio_equilizer.svg";
import audioEquilizer1 from "../../assets/Images/audio_equilizer1.png";

import audioBackground from "../../assets/Images/audio_background.svg";

// import loginVideo from '../../assets/video/login.mp4';

import infoIcon from "../../assets/Icon/info_icon.svg";

import selectFile from "../../assets/Icon/selectFile.svg";
import uploadIcon from "../../assets/Icon/upload_icon.svg";
import myLibraryIcon from "../../assets/Icon/myLibrary_icon.svg";
import gymLibraryIcon from "../../assets/Icon/gymLibrary_icon.svg";
import screenIcon from "../../assets/Icon/screen_icon.svg";
import audioIcon from "../../assets/Icon/media_clip/audio_icon.svg";
import videoIcon from "../../assets/Icon/media_clip/video_icon.svg";
import imageIcon from "../../assets/Icon/media_clip/image_icon.svg";
import settingIcon from "../../assets/Icon/media_clip/setting_icon.svg";
import deleteIcon from "../../assets/Icon/delete_icon.svg";
import deleteIcon1 from "../../assets/Icon/delete_icon1.svg";

import bottomRightIcon from "../../assets/Icon/bottomRight_icon.svg";
import fullScreenIcon from "../../assets/Icon/fullScreen_icon.svg";
import playIcon from "../../assets/Icon/play_icon.svg";
import retry from "../../assets/Icon/retry_icon.svg";
import upload from "../../assets/Icon/upload.svg";
import successfullMessageIcon from "../../assets/Icon/successfullMessage_icon.svg";
// import selectMediaIcon from '../../assets/Icon/select_media.svg';
import selectMediaIcon from "../../assets/Icon/selectMedia.svg";
import screenPreviewIcon from "../../assets/Icon/screen_preview.svg";
// import mediaAssetNoPreviewIcon from '../../assets/Icon/mediaAsset_noPreview.svg';
// import videoSlash from '../../assets/Icon/video_slash.svg';
import videoSlash from "../../assets/Icon/no_video.svg";
import mediaAssetNoPreviewIcon from "../../assets/Icon/no_image.svg";
import audioWave from "../../assets/Icon/audio_wave.svg";
import microphoneSlash from "../../assets/Icon/no_audio.svg";
// import microphoneSlash from '../../assets/Icon/microphone_slash.svg';
import memberIcon from "../../assets/Icon/member_icon.svg";
import plusIcon from "../../assets/Icon/plusIcon.svg";
import removeBoot from "../../assets/Icon/removeBoot.svg";
import mediaError from "../../assets/Icon/media_error.svg";
import copyLink from "../../assets/Icon/copy_link.svg";
import paymentOff from "../../assets/Icon/payment_off.svg";
import noDataIcon from "../../assets/Icon/noData_icon.svg";
import stripeBtnIcon from "../../assets/Icon/stripe_btn_icon.svg";
// import crossIcon from '../../assets/Icon/crossIcon.svg';

// Sidebar
import sidebar_dashboard from "../../assets/sidebar/dashboard.png";
import sidebar_ongoingClass from "../../assets/sidebar/ongoingClass.png";
import sidebar_scheduleClass from "../../assets/sidebar/scheduleClass.png";
import sidebar_upcomingClass from "../../assets/sidebar/upcomingClass.png";
import sidebar_classSummary from "../../assets/sidebar/classSummary.png";
import sidebar_member from "../../assets/sidebar/members.png";
import sidebar_coach from "../../assets/sidebar/coaches.png";
import sidebar_studio from "../../assets/sidebar/studio.png";
import sidebar_videoLibrary from "../../assets/sidebar/videoLibrary.png";
import sidebar_memberPayment from "../../assets/sidebar/memberPayment.png";
import sidebar_classTemplate from "../../assets/sidebar/classTemplate.png";
import sidebar_integration from "../../assets/sidebar/integration.png";
import sidebar_settings from "../../assets/sidebar/setting.png";

import feature_icon from "../../assets/Icon/featureIcon.svg";

import dummy_addCategoryIcon from "../../assets/Images/dummy_addCategoryIcon.png";
import crop_icon from "../../assets/Icon/crop_icon.png";
import upload_icon from "../../assets/Icon/upload_icon.png";
import warning from "../../assets/Icon/warning.svg";

import user from "../../assets/Image/user.svg";
import changePassword from "../../assets/Image/changePassword.svg";
import logout from "../../assets/Image/logOut.svg";
import camera from "../../assets/Image/camera.svg";
import help_center from "../../assets/Image/help_center.svg";

import stripe_logo from "../../assets/Image/stripe_logo.svg";
import group_logo from "../../assets/Image/group_logo.svg";
import payment_setting from "../../assets/Image/payment_setting.svg";
import video_tutorials from "../../assets/Image/video_tutorials.svg";
import schedule_training from "../../assets/Image/schedule_training.svg";
import contact_support from "../../assets/Image/contact_support.svg";
import getting_started from "../../assets/Image/getting_started.svg";
import help_center1 from "../../assets/Image/help_center1.svg";
import materixCalories from "../../assets/metrics/calories.svg";
import materixClasses from "../../assets/metrics/classes.svg";
import materixMinutes from "../../assets/metrics/minutes.svg";
import materixLive from "../../assets/metrics/live.svg";
import materixOndemand from "../../assets/metrics/ondemand.svg";
import materixTotalView from "../../assets/metrics/total_view.svg";
import materixUniqueView from "../../assets/metrics/unique_view.svg";
import materixUserImage from "../../assets/metrics/userImage.svg";
import materixNewMember from "../../assets/metrics/newMember.svg";
import materixActiveMember from "../../assets/metrics/activeMember.svg";
import materixChurnedMember from "../../assets/metrics/churnedMember.svg";
import materixNoClassMember from "../../assets/metrics/noClassMember.svg";
import materixTotalClass from "../../assets/metrics/totalClass.svg";
import materixLiveClass from "../../assets/metrics/liveClass.svg";
import materixOndemandClass from "../../assets/metrics/ondemandClass.svg";
import materixCancelClass from "../../assets/metrics/cancelClass.svg";
import materixExportIcon from "../../assets/metrics/exportIcon.svg";
import deepLink from "../../assets/metrics/deepLink.svg";

const selectIcon = (icon) => {
  switch (icon) {
    case "warning":
      return warning;
    case "stripe_logo":
      return stripe_logo;
    case "group_logo":
      return group_logo;
    case "payment_setting":
      return payment_setting;
    case "user":
      return user;
    case "changePassword":
      return changePassword;
    case "logout":
      return logout;
    case "camera":
      return camera;
    case "help_center":
      return help_center;
    case "video_tutorials":
      return video_tutorials;
    case "schedule_training":
      return schedule_training;
    case "contact_support":
      return contact_support;
    case "getting_started":
      return getting_started;
    case "help_center1":
      return help_center1;
    case "materixCalories":
      return materixCalories;
    case "materixMinutes":
      return materixMinutes;
    case "materixClasses":
      return materixClasses;
    case "materixOndemand":
      return materixOndemand;
    case "materixLive":
      return materixLive;
    case "materixTotalView":
      return materixTotalView;
    case "materixUniqueView":
      return materixUniqueView;
    case "materixUserImage":
      return materixUserImage;
    case "materixNewMember":
      return materixNewMember;
    case "materixActiveMember":
      return materixActiveMember;
    case "materixChurnedMember":
      return materixChurnedMember;
    case "materixNoClassMember":
      return materixNoClassMember;
    case "materixTotalClass":
      return materixTotalClass;
    case "materixLiveClass":
      return materixLiveClass;
    case "materixOndemandClass":
      return materixOndemandClass;
    case "materixCancelClass":
      return materixCancelClass;
    case "materixExportIcon":
      return materixExportIcon;

    case "upload_icon":
      return upload_icon;
    case "crop_icon":
      return crop_icon;
    case "feature_icon":
      return feature_icon;
    case "dummy_addCategoryIcon":
      return dummy_addCategoryIcon;
    case "dashboard":
      return dashboard;
    case "sidebar_ongoingClass":
      return sidebar_ongoingClass;
    case "sidebar_scheduleClass":
      return sidebar_scheduleClass;
    case "sidebar_upcomingClass":
      return sidebar_upcomingClass;
    case "sidebar_classSummary":
      return sidebar_classSummary;
    case "sidebar_member":
      return sidebar_member;
    case "sidebar_coach":
      return sidebar_coach;
    case "sidebar_studio":
      return sidebar_studio;
    case "sidebar_videoLibrary":
      return sidebar_videoLibrary;
    case "sidebar_memberPayment":
      return sidebar_memberPayment;
    case "sidebar_classTemplate":
      return sidebar_classTemplate;
    case "sidebar_integration":
      return sidebar_integration;
    case "sidebar_settings":
      return sidebar_settings;
    case "mediaError":
      return mediaError;
    case "removeBoot":
      return removeBoot;
    case "plusIcon":
      return plusIcon;
    case "memberIcon":
      return memberIcon;
    case "successfullMessageIcon":
      return successfullMessageIcon;
    case "retry":
      return retry;
    case "microphoneSlash":
      return microphoneSlash;
    case "audioWave":
      return audioWave;
    case "videoSlash":
      return videoSlash;
    case "playIcon":
      return playIcon;
    case "mediaAssetNoPreviewIcon":
      return mediaAssetNoPreviewIcon;
    case "selectMediaIcon":
      return selectMediaIcon;
    case "screenPreviewIcon":
      return screenPreviewIcon;
    case "bottomRightIcon":
      return bottomRightIcon;
    case "fullScreenIcon":
      return fullScreenIcon;
    case "audioBackground":
      return audioBackground;
    case "deleteIcon":
      return deleteIcon;
    case "deleteIcon1":
      return deleteIcon1;
    case "infoIcon":
      return infoIcon;
    case "screenIcon":
      return screenIcon;
    case "audioIcon":
      return audioIcon;
    case "videoIcon":
      return videoIcon;
    case "imageIcon":
      return imageIcon;
    case "settingIcon":
      return settingIcon;
    case "selectFile":
      return selectFile;
    case "myLibraryIcon":
      return myLibraryIcon;
    case "gymLibraryIcon":
      return gymLibraryIcon;
    case "uploadIcon":
      return uploadIcon;
    case "upload":
      return upload;
    case "upset":
      return upset;
    case "audioEquilizer1":
      return audioEquilizer1;
    case "audioEquilizer":
      return audioEquilizer;
    case "videoMute":
      return videoMute;
    case "downloadTransaction":
      return downloadTransaction;
    case "refund":
      return refund;
    case "pauseIcon":
      return pauseIcon;
    case "playIcons":
      return playIcons;
    case "cross_input":
      return cross_input;
    case "videoUnmute":
      return videoUnmute;
    case "members":
      return member;
    case "sendIcon":
      return sendIcon;
    case "gallaryView":
      return gallaryView;
    case "segmentView":
      return segmentView;
    // case 'loginVideo':
    //     return loginVideo;
    case "offline":
      return offline;
    case "template":
      return template;
    case "Running":
      return Running;
    // case 'Dance':
    //     return Dance;
    case "Sports":
      return Postnatal;
    case "Spinning":
      return Sports;
    case "Outdoors":
      return Stretch;
    case "strength":
      return Strength;
    case "Prenatal":
      return Prenatal;
    case "Motivation":
      return Motivation;
    case "Pilates":
      return Pilates;
    case "Boxing":
      return Boxing;
    case "Cycling":
      return Spinning;
    case "Medication":
    case "Meditation":
      return Medication;
    case "Bootcamp":
      return Bootcamp;
    case "Core":
      return Core;
    case "Barre":
      return Barre;
    case "Rowing":
      return Rowing;
    case "userCover":
      return userCover;
    case "Martial Arts":
      return Martial;
    case "Elliptical":
      return Elliptical;
    case "info":
      return Info;
    case "zym":
      return zym;
    case "zym1":
      return zym1;
    case "requestUser":
      return RequestUser;
    case "removeUser":
      return RemoveUser;
    case "rejectUser":
      return rejectUser;
    case "check":
      return check;
    case "caloriesDisable":
      return calorieIconDisable;
    case "calories":
      return calorieIcon;
    case "calorie":
      return calorie;
    case "DefaultImage":
      return DefaultImage;
    case "heart":
      return faHeart;
    case "group":
      return Group;
    case "groupDisable":
      return GroupDisable;
    case "activity":
      return ActivityDoneImg;
    case "coach":
      return CoachIcon;
    case "newCoach":
      return NewCoachIcon;
    case "newMember":
      return NewMemberIcon;
    case "payment":
      return PaymentIcon;
    case "hours":
      return HoursIcon;
    case "minMember":
      return MinMemberIcon;
    case "member":
      return MemberIcon;
    case "schedule":
      return ScheduleIcon;
    case "calender":
      return calendarIcon;
    case "time":
      return timeIcon;
    case "sidebar_dashboard":
      return sidebar_dashboard;
    case "sidebar_schedule":
      return Schedule;
    case "sidebar_ongoing":
      return Ongoing;
    case "sidebar_activity":
      return Activity;
    case "sidebar_recorded":
      return Recorded;
    case "Bitmap":
      return Bitmap;
    case "sidebar_messages":
      return Messages;
    case "sidebar_coaches":
      return Coaches;
    case "sidebar_members":
      return Members;
    case "sidebar_payment":
      return Payments;
    case "sidebar_setting":
      return Setting;
    case "sidebar_gym_studio":
      return GymStudio;
    case "header_play":
      return PlayIcon;
    case "header_pause":
      return PlayIcon;
    case "header_stop":
      return StopIcon;
    case "timer":
      return faHeart;
    case "calorieIcon":
      return calorieIcon;
    case "timerIcon":
      return timerIcon;
    case "timerIcon1":
      return timerIcon1;
    case "userDummy":
      return userDummy;
    case "verified":
      return verified;
    case "logo":
    case "tribe":
      return logo;
    case "newLogo":
      return newLogo;
    case "filter":
      return filter;
    case "checkImage":
      return checkImage;
    case "agreements":
      return agreements;
    case "accountDetails":
      return accountDetails;
    case "helpCenter":
      return helpCenter;
    case "privacyPolicy":
      return privacyPolicy;
    case "streamPlaceholder":
      return streamPlaceholder;
    case "streamPlaceholder1":
      return streamPlaceholder1;
    case "black":
      return blackImage;
    case "membersLive":
      return membersLive;
    case "memberLive":
      return memberLive;
    case "arrow":
      return arrow;
    case "downArrow":
      return downArrow;
    case "scheduleRoom":
      return scheduleRoom;
    case "waitingRoom":
      return waitingRoom;
    case "closedRoom":
      return closedRoom;
    case "openRoom":
      return openRoom;
    case "availableRoom":
      return availableRoom;
    case "deepLink":
      return deepLink;
    case "copyLink":
      return copyLink;
    case "paymentOff":
      return paymentOff;
    case "stripeBtnIcon":
      return stripeBtnIcon;
    case "noDataIcon":
      return noDataIcon;
    case "onDemandActivityWhite":
      return onDemandActivityWhite;
    case "onDemandActivity":
      return onDemandActivity;
    case "copyIcon":
      return copyIcon;
    case "mindbody":
      return mindBodyLogo;
    case "marianatek":
      return marianaTek;
    case "companyPH":
      return companyPH;
    case "activationPending":
      return activationPending;
    case "activityImage":
      return activityImage;
    case "addMember":
      return addMember;
    case "downloadIcon":
      return downloadIcon;
    case "excelUpload":
      return excelUpload;
    case "notValid":
      return notValid;
    case "validEmail":
      return validEmail;
    case "publicLock":
      return publicLock;
    case "passwordLock":
      return passwordLock;
    case "crossIcons":
      return crossIcons;
    case "crossIcon":
      return crossIcon;
    case "arrowIcon":
      return arrowIcon;
    // Side Navigation
    case "upcoming_class":
      return upcomingClass;
    case "class_summary":
      return classSummary;
    case "video_library":
      return videoLibrary;
    case "integration":
      return integration;
    case "vod":
      return vod;
    case "live":
      return live;

    // Template
    case "delete":
      return deletes;
    case "copy":
      return copy;
    case "share":
      return share;
    case "shareActive":
      return shareActive;
    case "shareDisable":
      return shareDisable;
    case "edit":
      return edit;

    // Activity Type
    case "barre":
      return barre;
    case "bootcamp":
      return bootcamp;
    case "boxing":
      return boxing;
    case "calisthenics":
      return Calisthenics;
    case "cardio":
      return cardio;
    case "celebrity":
      return celebrity;
    case "core":
      return core;
    case "cycling":
      return cycling;
    case "dance":
      return dance;
    case "functional":
      return Functional;
    case "hiit":
      return hiit;
    case "lowerBody":
      return lowerBody;
    case "meditation":
      return meditation;
    case "mobility":
      return mobility;
    case "other":
      return other;
    case "pilates":
      return pilates;
    case "seniorFitness":
      return seniorFitness;
    case "sports":
      return sports;
    case "streching":
      return streching;
    case "strengths":
      return strengths;
    case "toning":
      return toning;
    case "upperBody":
      return upperBody;
    case "yoga":
      return yoga;

    // Icon
    case "activeUp":
      return activeUp;
    case "dropdown":
      return dropdown;
    case "activeDown":
      return activeDown;
    case "down":
      return down;
    case "up":
      return up;
    case "addTemplate":
      return addTemplate;
    case "search":
      return search;
    case "noLevel":
      return noLevel;
    case "high":
      return high;
    case "low":
      return low;
    case "medium":
      return medium;
    case "back":
      return back;

    // Payment
    case "cardBackground":
      return cardBackground;
    case "visa":
      return visaLogo;
    case "amex":
      return americanExpress;
    case "diners":
      return diner;
    case "discover":
      return discover;
    case "jcb":
      return jcb;
    case "addCardFooterImage":
      return addCardFooterImage;
    case "unionpay":
      return union;
    case "mastercard":
      return mastercard;
    case "streamDisabled":
    case "cameraDisabled":
      return streamDisabled;
    case "Subtract":
      return Subtract;
    case "streamEnabled":
    case "cameraEnabled":
      return streamEnabled;
    case "audioEnabled":
      return audioEnabled;
    case "userMikeSVG":
      return userMikeSVG;
    case "userMikeDisabledSVG":
      return userMikeDisabledSVG;
    case "userMike":
      return userMike;
    case "userMikeDisabled":
      return userMikeDisabled;
    case "audioDisabled":
      return audioDisabled;
    case "pinkCard":
      return pinkCard;
    case "magentaCard":
      return magentaCard;
    case "downloadInvoice":
      return downloadInvoice;
    case "noStream":
      return noStream;
    case "noStreaming":
      return noStreaming;
    case "editIconAnnouncement":
      return editIconAnnouncement;
    case "deleteIconAnnouncement":
      return deleteIconAnnouncement;
    case "uploadImgPlaceholder":
      return uploadImgPlaceholder;
    case "noDataAnnouncement":
      return noDataAnnouncement;

    default:
      return userDummy;
  }
};

const colorSelector = (heartRate) =>
  dynamicColorSelector(heartRate, variables.defaultColor);

const dynamicColorSelector = (heartRate, defaultColor) => {
  switch (true) {
    case heartRate < 0:
      return variables.extraLow;
    case heartRate > 0 && heartRate < 60:
      return variables.veryLow;
    case heartRate >= 60 && heartRate < 70:
      return variables.low;
    case heartRate >= 70 && heartRate < 80:
      return variables.medium;
    case heartRate >= 80 && heartRate < 90:
      return variables.high;
    case heartRate >= 90:
      return variables.veryHigh;
    default:
      return defaultColor;
  }
};

const textColorSelector = (heartRate) =>
  dynamicColorSelector(heartRate, variables.defaultColorText);

export const classSelector = (heartRate, text = false) => {
  switch (true) {
    case heartRate < 0:
      return "extraLow";
    case heartRate > 0 && heartRate < 60:
      return "veryLow";
    case heartRate >= 60 && heartRate < 70:
      return "low";
    case heartRate >= 70 && heartRate < 80:
      return "medium";
    case heartRate >= 80 && heartRate < 90:
      return "high";
    case heartRate >= 90:
      return "veryHigh";
    default:
      return text ? "defaultColorText" : "defaultColor";
  }
};

const errorHandler = (value) => {
  switch (value) {
    case "passwordNotMatch":
      return "Password not match.";
    case "alreadyEmail":
      return "There’s is already an account with this email address. Log in if you already have an account.";
    case "maxDate":
      return `An class cannot be scheduled for longer than three months`;
    case "timeError":
      return `A class that starts in less than 5 minutes from now can not be scheduled`;
    case "timeErrorEdit":
      return `An class cannot be edited 5 minutes before it starts`;
    case "invalidEmail":
      return "We can’t find an account for that email address. Please try again, or create an account";
    case "wrongPassword":
      return "The password you entered isn’t right. Please try again";
    case "wrongMemberShipcode":
      return "No gym or fitness studio was found with this membership code";
    case "alreadyMemberShipcode":
      return "Gym or fitness studio already linked with this account";
    default:
      return "";
  }
};
const checkError = (value) => {
  switch (value) {
    case "User already exists. Please try with another email address.":
      return "alreadyEmail";
    case "The password you entered isn’t right. Please try again.":
      return "wrongPassword";
    case "We can’t find an account for that email address. Please try again.":
      return "invalidEmail";
    case "No gym or fitness studio was found with this membership code.":
      return "wrongMemberShipcode";
    case "Gym or fitness studio already linked with this account.":
      return "alreadyMemberShipcode";
    default:
      return "";
  }
};

export const errorText = {
  alreadyEmail: "",
};

const filterSelect = (value) => {
  switch (value) {
    case "member":
      return [
        { name: "Birthday Period", value: "users.dob" },
        // { name: 'Last Attended Period', value: 'last_activity_attended_at' },
        { name: "Added On Period", value: "user_gym.approved_at" },
        // { name: 'Class Completed Range', value: 'number_of_activities_done' }
      ];
    case "coach":
      return [
        { name: "Birthday Period", value: "users.dob" },
        // { name: 'Last Attended Period', value: 'last_activity_attended_at' },
        { name: "Added On Period", value: "user_gym.approved_at" },
        // { name: 'Class Completed Range', value: 'number_of_activities_done' }
      ];
    case "date":
      return [
        { name: "Created On", value: "created_at" },
        { name: "Edited On", value: "updated_at" },
        { name: "Last Used On", value: "last_used_at" },
      ];
    case "status":
      return [
        { name: "Approved", value: "approved" },
        { name: "Reject", value: "reject" },
      ];
    case "days":
    default:
      return [
        // {name:'All time',value:'all'},
        // {name:'90 days',value:'90'},
        { name: "7 Days", value: "in_last_7_days" },
        { name: "15 Days", value: "in_last_15_days" },
        { name: "30 Days", value: "in_last_30_days" },
      ];
  }
};

// const goToLogin = () => this.props.history.push('/Login');

export {
  selectIcon,
  colorSelector,
  textColorSelector,
  errorHandler,
  checkError,
  filterSelect,
  SVG,
};
